import { Component, inject, signal, computed } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { ExportService } from '../export.service'

@Component({
    selector: 'app-export-toast',
    templateUrl: './export-toast.component.html',
    imports: [TranslateModule],
})
export class ExportToastComponent {
    readonly exportService = inject(ExportService)

    // Inline close-confirmation state (purely local UI)
    readonly showCloseConfirm = signal(false)

    readonly isRunning = computed(() => this.exportService.status() === 'running')
    readonly isComplete = computed(() => this.exportService.status() === 'complete')
    readonly hasError = computed(() => this.exportService.status() === 'error')

    onDownload(): void {
        this.exportService.downloadExport()
    }

    onSendEmail(): void {
        if (this.isComplete()) {
            this.exportService.requestEmailForCompleted()
        } else {
            this.exportService.requestEmailForRunning()
        }
        this.exportService.emailSent.set(true)
    }

    onCloseClick(): void {
        if ((this.isRunning() || this.isComplete()) && !this.exportService.emailSent() && !this.exportService.fileDownloaded()) {
            this.showCloseConfirm.set(true)
        } else {
            this.confirmClose(false)
        }
    }

    confirmClose(wantEmail: boolean): void {
        if (wantEmail) {
            if (this.isRunning()) {
                this.exportService.requestEmailForRunning()
            } else {
                this.exportService.requestEmailForCompleted()
            }
        }
        this.showCloseConfirm.set(false)
        this.exportService.hide()
    }

    cancelClose(): void {
        this.showCloseConfirm.set(false)
    }
}
